"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _constants = require("../../constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

var _Headings = require("../Headings");

var _dashedStroke = _interopRequireDefault(require("./assets/dashedStroke"));

var _addCircle = _interopRequireDefault(require("./assets/addCircle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const setBGColor = (colour = '') => {
  switch (colour) {
    case 'success':
      return _constants.colours.success;

    case 'alert':
    case 'warning':
      return _constants.colours.amber;

    case 'fail':
      return _constants.colours.red;

    case 'default':
      return _constants.colours.cardTop;

    default:
      return colour[0] === '#' ? colour : _constants.colours.cardTop;
  }
};

const DefaultCard = (0, _styledComponents.default)(({
  addNew,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement(_core.Card, props, children))`
	&.MuiCard-root {
		background-color: ${({
  colour
}) => !colour ? null : setBGColor(colour)};
		height: ${props => props.height ? `${props.height}px` : null};
		display: flex;
		flex-direction: column;
	}
	&.MuiCard-root *:first-child {
		flex: 1;
	}
`;
const AddNewCardBase = (0, _styledComponents.default)(DefaultCard)`
	&.MuiCard-root {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-image: ${_dashedStroke.default};
		box-shadow: none;
	}
	&.MuiCard-root *:first-child {
		flex: none;
	}
	&.MuiCard-root * {
		height: 100%;
		box-sizing: border-box;
	}
	&.MuiCard-root h4 {
		height: auto;
	}
`;
const AddNewContainerBox = (0, _styledComponents.default)(_core.Box)`
	&.MuiBox-root {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: ${props => props.minHeight}px;
		flex-direction: column;
		color: ${_constants.colours.inactiveState};
	}
	&.MuiBox-root * {
		height: auto;
	}
`;
const IconBox = _styledComponents.default.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 64px;
	width: 64px;
`;
const Title = (0, _styledComponents.default)(_Headings.H4)`
	font-size: 22px;
	color: inherit;
`;

const CustomCard = ({
  addNew,
  addNewTitle,
  colour,
  height,
  children,
  minHeight,
  ...otherProps
}) => {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, addNew && /*#__PURE__*/_react.default.createElement(AddNewCardBase, _extends({
    variant: "outlined",
    elevation: 10,
    addNew: true,
    colour: colour,
    height: height
  }, otherProps), /*#__PURE__*/_react.default.createElement(_core.CardActionArea, {
    component: "div",
    disableRipple: true
  }, /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement(AddNewContainerBox, {
    minHeight: minHeight
  }, /*#__PURE__*/_react.default.createElement(IconBox, null, /*#__PURE__*/_react.default.createElement("img", {
    width: "53",
    src: _addCircle.default,
    alt: "Add"
  })), /*#__PURE__*/_react.default.createElement(Title, null, addNewTitle))))), !addNew && (colour || height) && /*#__PURE__*/_react.default.createElement(DefaultCard, _extends({
    colour: colour,
    height: height,
    variant: "elevation",
    elevation: 10
  }, otherProps), children), !addNew && !(colour || height) && /*#__PURE__*/_react.default.createElement(_core.Card, _extends({
    variant: "elevation",
    elevation: 10
  }, otherProps), children));
};

CustomCard.propTypes = {
  addNew: _propTypes.default.bool,
  addNewTitle: _propTypes.default.string,
  minHeight: _propTypes.default.number,
  height: _propTypes.default.number
};
CustomCard.defaultProps = {
  addNew: false,
  addNewTitle: '',
  minHeight: 200,
  height: null
};
var _default = CustomCard;
exports.default = _default;